import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import { puede } from "../../../../permisos/permisos";

function AbonosProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [text, setText] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedProveedorNombre, setSelectedProveedorNombre] = useState("");
  const [fecha, setFecha] = useState(hoy);

  const [selectedBanco, setSelectedBanco] = useState("");
  // Moneda en que sale el dinero del banco; si difiere de la factura se captura el TC.
  const [monedaPago, setMonedaPago] = useState("MXN");
  const [tipoCambio, setTipoCambio] = useState(0);
  const [bancos, setBancos] = useState([]);

  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [total, setTotal] = useState(0);
  // const [importeAplicar, setImporteAplicar] = useState(0);
  // const [saldoAplicar, setSaldoAplicar] = useState(0);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [inputFields, setInputFields] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useMemo(() => {
    axios
      .get(`${URL_PROVEEDORES}Proveedores`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_COMPRAS}Proveedor/${selectedProveedor}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCargos = response.data;
        let arrayTabla = allCargos
          .map((a) => {
            return {
              id: a._id,
              fecha: a.fecha,
              total_costo: a.total_costo,
              saldo: parseFloat(a.saldo).toFixed(2),
              compra: a.idCompras,
              factura: a.factura_proveedor,
              importe: 0,
              proveedores: a.proveedores[0]._id,
              observaciones: "NA",
              moneda: a.moneda || "MXN",
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setInputFields(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

  
  }, [selectedProveedor]);

const handleChangeInputImporte = (value, name, id) => {
  const newInputFields = inputFields.map((i) => {
    if (id === i.id) {
      const numericValue = parseFloat(value) || 0;
      if (numericValue <= i.saldo) {
        i[name] = numericValue;
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El Pago excede el Saldo",
        });
      }
    }
    return i;
  });
  setInputFields(newInputFields);
  ActualizaTotales();
};



  function ActualizaTotales() {
    let TEfe = inputFields.map((c) => parseFloat(c.importe));
    let TE = TEfe.reduce((t, total, index) => t + total, 0);

    setTotal(TE);

    // setSaldoAplicar(importeAplicar - TE);
  }

  function savePago() {
    if (
      value != null &&
      selectedBanco != ""
    ) {
      // if (saldoAplicar == 0 && importeAplicar == total) {
        Swal.fire({
          title: "Estas seguro?",
          text: "Se registrará el abono",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Enviar!",
        }).then((result) => {
          if (result.isConfirmed) {
            toggleProgreso();
            let totalMails = inputFields.length
            inputFields.map((a) => {
              if (a.importe > 0) {
                axios
                  .post(
                    URL_ABONOS_PROVEEDORES,
                    {
                      fecha,
                      importe: parseFloat(a.importe),
                      proveedores: selectedProveedor,
                      compras: a.id,
                      bancos: selectedBanco,
                      observaciones: a.observaciones,
                      codigoAgrupado,
                      // La moneda de la compra define que saldo del proveedor baja.
                      moneda: a.moneda || "MXN",
                      monedaPago,
                      tipoCambio: Number(tipoCambio) || 0,
                      editado:"No"
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    axios.patch(
                      `${URL_COMPRAS}/${a.id}`,
                      {
                        saldo: a.saldo - a.importe,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );

                    axios
                    .post(
                      `${URL_MOVIMIENTOS_BANCOS}`,
                      {
                        fecha,
                        importe: -a.importe,
                        tipo:"Egreso",
                        bancos: selectedBanco,
                        abonosProveedores:data.data._id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    
                    totalMails = totalMails - 1;
                    if (totalMails == 0) {
                      Swal.fire("Good job!", "Creado con exito", "success");

                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      // footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              } else {
                totalMails = totalMails - 1;
              }
            });

          }
        });
      // } else {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "Todavia te queda Saldo por aplicar",
      //   });
      // }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes completar todo el formulario",
      });
    }
  }

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };


  const options = proveedores.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  // function IA(e) {
  //   setImporteAplicar(e);

  //   let TEfe = inputFields.map((c) => parseFloat(c.importe));
  //   let TE = TEfe.reduce((t, total, index) => t + total, 0);
  //   setTotal(TE);

  //   setSaldoAplicar(e - TE);
  // }

  return (
    <>
      <Header />
      <br />
      <br />
      {puede(user, "cxp.abonos.crear") ? (
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-dollar-sign" style={{ marginRight: 8, color: "#10b981" }} />
                Captura un Pago
              </h3>
            </div>
          </div>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-money-check-alt" />
                  <span className="form-section-title">Datos del Pago</span>
                </div>
                <div className="form-section-body">
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={3}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedProveedor) => {
                      if (selectedProveedor) {
                        setValue(selectedProveedor);
                        setSelectedProveedor(selectedProveedor._id);
                        setSelectedProveedorNombre(
                          selectedProveedor.nombre_comercial
                        );
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>

                <Col md={2}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      setSelectedBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Label className="mr-sm-2">Moneda del pago</Label>
                  <Input
                    type="select"
                    value={monedaPago}
                    onChange={(e) => {
                      setMonedaPago(e.target.value);
                      setTipoCambio(0);
                    }}
                  >
                    <option value="MXN">Pesos (MXN)</option>
                    <option value="USD">Dólares (USD)</option>
                  </Input>
                </Col>

                {/* Solo hace falta TC si el banco paga en una moneda distinta a la de alguna factura. */}
                {inputFields.some((f) => (f.moneda || "MXN") !== monedaPago) && (
                  <Col md={2}>
                    <Label className="mr-sm-2">Tipo de cambio</Label>
                    <Input
                      type="number"
                      placeholder="Ej. 17.50"
                      value={tipoCambio}
                      onChange={(e) => setTipoCambio(e.target.value)}
                    />
                  </Col>
                )}

                <Col md={1}>
                  <h4 align="right">
                    Total Pago{"  "}
                    <Badge
                      id="Total"
                      color="danger"
                      className="BadgeSize badge-pill"
                    >
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(total)}
                    </Badge>
                  </h4>
                </Col>
              </Row>
              <br />
                </div>
              </div>
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-list" />
                  <span className="form-section-title">Detalle</span>
                </div>
                <div className="form-section-body">
              {/* <Row>
                <Col md={1}>
                  <Label>Importe Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={importeAplicar}
                    className={`form-control`}
                    onValueChange={(value, name) => IA(value)}
                  />
                </Col>
                <Col md={1}>
                  <Label>Saldo Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={saldoAplicar}
                    className={`form-control`}
                    disabled
                  />
                </Col>
              </Row>
              <br /> */}
              <Row>
                {/* Tabla Cargos */}
                <br />
                <br />
                <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Compra</th>
                      <th>Factura</th>
                      <th>Moneda</th>
                      <th>Total</th>
                      <th>Abonos</th>
                      <th>Saldo</th>
                      <th>Importe</th>
                      <th>Observaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputFields.map((a) => (
                      // <div key={a.id}>
                      <tr>
                        <td>{a.fecha}</td>
                        <td>{a.compra}</td>
                        <td>{a.factura}</td>
                        <td>
                          <span className="badge" style={{ backgroundColor: a.moneda === "USD" ? "#0d6efd" : "#6c757d", color: "#fff" }}>
                            {a.moneda || "MXN"}
                          </span>
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_costo)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_costo - a.saldo)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.saldo)}
                        </td>
                        <td>
                          <Input
                            type="number"
                            step="0.01"
                            min="0"
                            className="form-control"
                            name="importe"
                            value={a.importe}
                            onChange={(e) =>
                              handleChangeInputImporte(
                                e.target.value,
                                e.target.name,
                                a.id
                              )
                            }
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                      </tr>
                      // </div>
                    ))}

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        Total
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(total)}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                  <br />
                </Table>

                {/* Termina tabla cargos */}
              </Row>
                </div>
              </div>
            </FormGroup>
            <br />
            <div className="submit-bar">
              <Button
                href="/ListadoAbonosProveedores"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              <Button className="btn btn-success" onClick={savePago}>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Registrar
              </Button>
            </div>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default AbonosProveedoresCreate;
